<template>
    <div ref="$row" class="row desktop">
        <div class="label">{{ item.headline || item.service }}</div>
        <div class="value" v-html="item.body || item.professional" />
        <div v-show="!!item.linkUrl.length" class="arrow">
            <svg viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.35 15.54L14.34 15.09C14.76 11.97 16.56 9.36 18.9 8.64H0V6.9H18.9C16.56 6.18 14.76 3.57 14.34 0.450001L16.35 0C16.62 4.35 19.29 6.6 22.5 6.9V8.64C19.29 8.94 16.62 11.19 16.35 15.54Z"
                    fill="black"
                />
            </svg>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        item?: CmsItem;
    }>(),
    {
        item: () => ({})
    }
);

const item = computed(() => props.item);
const $row = ref<HTMLDivElement | null>(null);
const isDesktop = useMediaQuery('(min-width: 768px)');

onMounted(() => {
    if (isDesktop.value && item.value?.media?.length && $row.value) {
        $row.value.dataset.media = item.value.media[0].webp;
        new reveralImage($row.value);
    }
});
</script>
